import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const requireAuth = () => (from, to, next) => {
  if (store.getters.getAuth) return next() // isAuth === true면 페이지 이동
  next('/login') // isAuth === false면 다시 로그인 화면으로 이동
}

export default new Router({
  mode: 'history',
  routes: [
    // watersbuy Admin
    {
      path: '/',
      component: () => import('@/components/Admin'),
      beforeEnter: requireAuth(),
      children: [
        {//홈
          path: '/home',
          name: 'Home',
          component: () => import('@/components/Home')
        },
        {//가입회원 
          path: '/users',
          name: 'Users',
          component: () => import('@/components/users/Users')
        },
        {//관리자
          path: '/users/admin',
          name: 'UsersOfAdmin',
          component: () => import('@/components/users/UsersOfAdmin')
        },
        {//Terms 
          path: '/terms',
          name: 'Terms',
          component: () => import('@/components/terms/Terms')
        },
        {//model 
          path: '/model',
          name: 'Model',
          component: () => import('@/components/model/Model')
        },
        {//model 
          path: '/filter/:modelId',
          name: 'FilterManagement',
          component: () => import('@/components/model/Filter')
        },
        {//model filter set
          path: '/filter-set/:modelId',
          name: 'FilterSetManagement',
          component: () => import('@/components/model/FilterSet')
        },
        {//Subscription 
          path: '/subscriptions',
          name: 'Subscription',
          component: () => import('@/components/subscriptions/Subscription')
        },
         {//Subscription 
          path: '/subscriptionDetail/:id/:type',
          name: 'SubscriptionDetail',
          component: () => import('@/components/subscriptions/SubscriptionDetail')
        },
        {//OneTime 
          path: '/one-time-services',
          name: 'OneTimeService',
          component: () => import('@/components/subscriptions/OneTimeService')
        },
         {//OneTime 
          path: '/oneTimeServiceDetail/:id/:type',
          name: 'OneTimeServiceDetail',
          component: () => import('@/components/subscriptions/OneTimeServiceDetail')
        },
         {//push template 
          path: '/pushTemplate',
          name: 'PushTemplate',
          component: () => import('@/components/push/Template')
        },
        {//push Log 
          path: '/pushSend',
          name: 'PushSend',
          component: () => import('@/components/push/PushSend')
        },
        {//push Log 
          path: '/pushLog',
          name: 'PushLog',
          component: () => import('@/components/push/PushLog')
        },
        {//공지사항
          path: '/boards/:category',
          name: 'Notice',
          component: () => import('@/components/boards/Boards')
        },
        {//문의사항
          path: '/boards/:category',
          name: 'Question',
          component: () => import('@/components/boards/Boards')
        },
        {//FAQ
          path: '/boards/:category',
          name: 'Faq',
          component: () => import('@/components/boards/Boards')
        },
        {//광고주문의
          path: '/boards_spon/question_spon',
          name: '광고주 의뢰 문의',
          component: () => import('@/components/boards/BoardsSpon')
        },
        {
          path: '/admin/password',
          name: 'AdminPassword',
          component: () => import('@/components/common/AdminPassword')
        },
        {//selfManage 
          path: '/selfManage/:modelId',
          name: 'SelfManage',
          component: () => import('@/components/selfManage/SelfManage')
        },
        {//selfManageBoard 
          path: '/selfManageBoard',
          name: 'SelfManageBoard',
          component: () => import('@/components/selfManage/SelfManageBoard')
        },
        {//SelfManageContents 
          path: '/selfManageContents/:modelId/:code',
          name: 'SelfManageContents',
          component: () => import('@/components/selfManage/SelfManageContents')
        },
        {//SelfManageContents 
          path: '/selfManageContentsDetail/:modelId/:up_code/:code',
          name: 'SelfManageContentsDetail',
          component: () => import('@/components/selfManage/SelfManageContentsDetail')
        },
        {//SelfManageContents 
          path: '/selfManageContentsInfo/:modelId/:up_code/:code',
          name: 'SelfManageContentsInfo',
          component: () => import('@/components/selfManage/SelfManageContentsInfo')
        },
        {//Product 
          path: '/product/list',
          name: 'Product',
          component: () => import('@/components/product/Product')
        },
        {//ProductFilter 
          path: '/product/filter',
          name: 'ProductFilter',
          component: () => import('@/components/product/ProductFilter')
        },
        {//ProductSetManage
          path: '/product/set',
          name: 'ProductSetManage',
          component: () => import('@/components/product/ProductSetManage')
        },
        {//ProductQuestionList
          path: '/product/question',
          name: 'ProductQuestionList',
          component: () => import('@/components/product/ProductQuestionList')
        },
        {//Payment
          path: '/payment',
          name: 'Payment',
          component: () => import('@/components/product/Payment')
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/components/Login')
    },
    {
      path: '*',
      name: 'error404',
      component: { template: '<div>Access Denied..</div>' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js